/**
 * Shared locale configuration
 * This file contains pure constants and types that can be imported anywhere
 * (both server and client components)
 */

// Supported locales
export const locales = ['de', 'en', 'fr', 'es', 'ar', 'tr', 'ru'] as const;
export type Locale = (typeof locales)[number];

// Default locale
export const defaultLocale: Locale = 'de';
